// autoHideHeader.js
const initStickyHeader = () => {
    const header = document.querySelector('body.sticky-header header');
    if (!header) return;

    const HIDE_AFTER_TOP = 400; //hide after first x px
    const SCROLL_TO_HIDE   = 200; //hide header aftef scrolling down x px
    const REVEAL_DELTA   = 200; //how much to roll up to show again

    let lastY       = window.scrollY;
    let navHidden   = false;
    let peakScrollY = 0;
    let downFromShow       = 0;
    let ticking     = false;

    const isMenuOpened = _ =>
        document.querySelector('.navbar-collapse.show');
    const isWhispererOpened = _ =>
        document.querySelector('.search.search--active');
    const isLangsMenuOpened = _ =>
        document.querySelector('.dropdown--langs .dropdown-toggle.show');

    const rafHandler = _ => {
        const y = window.scrollY;

        /* scrolling down */
        if (y > lastY) {
            const delta = y - lastY;
            downFromShow += delta;

            if (
                !navHidden &&
                y > HIDE_AFTER_TOP &&
                downFromShow >= SCROLL_TO_HIDE &&
                !isMenuOpened() &&
                !isWhispererOpened() &&
                !isLangsMenuOpened()
            ) {
                header.classList.add('nav-hidden');
                navHidden   = true;
                peakScrollY = y;           // top, we calculate reveale from there
            }

            if (navHidden) {
                peakScrollY = Math.max(peakScrollY, y);
            }
        }

        /* scrolling up */
        else if (y < lastY) {
            downFromShow = 0;            //resetting
            if (navHidden && peakScrollY - y >= REVEAL_DELTA) {
                header.classList.remove('nav-hidden');
                navHidden = false;
            }
            if (y <= HIDE_AFTER_TOP) {
                header.classList.remove('nav-hidden');
                navHidden = false;
            }
        }

        lastY  = y;
        ticking = false;
    };

    const onScroll = () => {
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(rafHandler);
        }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
};

export default initStickyHeader;